__turbopack_context__.v({
  "is_active": "CrqL6W_is_active",
  "nav_link": "CrqL6W_nav_link",
});
